"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _findIndex = _interopRequireDefault(require("lodash/fp/findIndex"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _filter = _interopRequireDefault(require("lodash/fp/filter"));
var _identity = _interopRequireDefault(require("lodash/fp/identity"));
var _hasFocus = _interopRequireDefault(require("./hasFocus"));
var _tabbable = _interopRequireDefault(require("./tabbable"));
var isAtEnd = function isAtEnd(index, direction) {
  return function (els) {
    if (direction === 'previous' && index === 0) {
      return true;
    }
    if (direction === 'next' && index === els.length - 1) {
      return true;
    }
    return false;
  };
};
var getNextIndex = function getNextIndex(current, length) {
  return {
    next: function next() {
      return Math.abs(current + 1) % length;
    },
    previous: function previous() {
      return current <= 0 ? length - 1 : Math.abs(current - 1) % length;
    }
  };
};
var scopedFocus = function scopedFocus(root) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    circular = _ref.circular,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'next' : _ref$direction,
    _ref$filter = _ref.filter,
    predicate = _ref$filter === void 0 ? _identity["default"] : _ref$filter,
    _ref$displayCheck = _ref.displayCheck,
    displayCheck = _ref$displayCheck === void 0 ? 'none' : _ref$displayCheck;
  var tabbableEls = (0, _compose["default"])((0, _filter["default"])(predicate), Array.from, (0, _tabbable["default"])({
    displayCheck: displayCheck
  }))(root);
  var currentFocusedIndex = (0, _findIndex["default"])(_hasFocus["default"])(tabbableEls);
  var target = tabbableEls[getNextIndex(currentFocusedIndex, tabbableEls.length)[direction]()];
  if (circular || !isAtEnd(currentFocusedIndex, direction)(tabbableEls)) {
    target && target.focus();
  }
};
var _default = exports["default"] = scopedFocus;